import { ReactNode } from "react";

import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import Box from "@mui/material/Box";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

export interface DialogTitleProps {
  title?: string;
  subTitle?: string;
  children?: ReactNode;
  onClose: () => void;
}

const StyledDialogTitle = (props: DialogTitleProps): JSX.Element => {
  const { children, onClose, title, subTitle, ...other } = props;

  const theme = useTheme();

  return (
    <DialogTitle
      component="div"
      sx={{
        p: 0,
        marginBottom: "2em",
        textAlign: "center",
      }}
      {...other}
    >
      {children && children}
      {title && <Typography variant="h4">{title}</Typography>}
      {subTitle && (
        <Box
          sx={{
            textAlign: "center",
          }}
        >
          <Typography
            variant="body2Regular"
            color={theme => theme.palette.text.secondary}
            fontSize="0.75em"
          >
            {subTitle}
          </Typography>
        </Box>
      )}
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 14,
          top: 18,
          color: theme.palette.text.primary,
        }}
      >
        <HighlightOffRoundedIcon />
      </IconButton>
    </DialogTitle>
  );
};

export default StyledDialogTitle;
